import { downloadFile, generateBlob } from '@chilecompra/react-kit'
import { makeActionCreator } from '../../config/store/utils'
import { getQuoteBid, getResultExcel } from '../../services/sellerQuote'
import { makeSecondCallQuote } from '../../services/quote'
import { onGetQuoteSummaryThunk } from '../QuoteBasicInformation/QuoteBasicInformation.actions'

export const GET_QUOTE_BID_SEE_DETAIL = 'GET_QUOTE_BID_SEE_DETAIL'
export const GET_QUOTE_BID_SEE_DETAIL_ERROR = 'GET_QUOTE_BID_SEE_DETAIL_ERROR'
export const GET_QUOTE_BID_SEE_DETAIL_SUCCESS = 'GET_QUOTE_BID_SEE_DETAIL_SUCCESS'
export const onGetQuoteBidSeeDetail = makeActionCreator(GET_QUOTE_BID_SEE_DETAIL)
export const onGetQuoteBidSeeDetailError = makeActionCreator(GET_QUOTE_BID_SEE_DETAIL_ERROR, 'payload')
export const onGetQuoteBidSeeDetailSuccess = makeActionCreator(GET_QUOTE_BID_SEE_DETAIL_SUCCESS, 'payload')
export const onGetQuoteBidSeeDetailThunk = payload => async dispatch => {
  dispatch(onGetQuoteBidSeeDetailSuccess({ quoteBidDetail: {} }))
  dispatch(onGetQuoteBidSeeDetail())

  try {
    const { data } = await getQuoteBid({ bidId: payload.bidId })
    const quoteBidDetail = {
      amount: data.payload.montoTotal,
      attachedFiles: data.payload.documentosAdjuntos.map(attachedFile => ({
        id: attachedFile.id,
        name: attachedFile.filename
      })),
      businessName: data.payload.razonSocial,
      businessDni: data.payload.rutRazonSocial,
      detail: data.payload.detalle,
      dispatchValue: data.payload.valorDespacho,
      dni: data.payload.rut,
      effectiveDate: data.payload.fechaVigencia.split(' ')[0],
      name: data.payload.nombreApellido,
      nethworth: data.payload.valorNeto,
      products: data.payload.prCotizacion.map(product => ({
        id: product.solicitudCotizacionProductoId,
        productCode: product.codigoProducto,
        quantity: product.cantidad,
        unitPrice: product.precioUnitario,
        amount: product.montoTotal,
        unit: product.unidad,
        description: product.descripcion,
        name: product.nombre,
        include: product.incluir
      })),
      sendDate: data.payload.fechaEnvio.split(' ')[0],
      taxation: data.payload.impuesto.nombre,
      taxationValue: data.payload.valorImpuesto,
      unitValue: data.payload.valorUnitario,
      DJAditionalDetail: data.payload.detalleAdicionalDJ,
      DJBeneficiaries: data.payload.beneficiariosFinales,
      DJIdRespuesta: data.payload.idRespuesta,
      id: payload.bidId
    }

    return dispatch(onGetQuoteBidSeeDetailSuccess({ quoteBidDetail }))
  } catch (error) {
    return dispatch(onGetQuoteBidSeeDetailError({ error }))
  }
}

export const GET_RESULT_EXCEL = 'GET_RESULT_EXCEL'
export const GET_RESULT_EXCEL_ERROR = 'GET_RESULT_EXCEL_ERROR'
export const GET_RESULT_EXCEL_SUCCESS = 'GET_RESULT_EXCEL_SUCCESS'
export const onGetResultExcel = makeActionCreator(GET_RESULT_EXCEL)
export const onGetResultExcelError = makeActionCreator(GET_RESULT_EXCEL_ERROR, 'payload')
export const onGetResultExcelSuccess = makeActionCreator(GET_RESULT_EXCEL_SUCCESS, 'payload')
export const onGetResultExcelThunk = payload => async dispatch => {
  dispatch(onGetResultExcel())

  try {
    const response = await getResultExcel({ quoteId: payload.quoteId })
    const blob = generateBlob(response.data, response.headers['content-type'])
    downloadFile(blob, 'Cotizaciones')
    return dispatch(onGetResultExcelSuccess())
  } catch (error) {
    return dispatch(onGetResultExcelError({ error }))
  }
}

export const DIALOG_CLOSE_SUCCESS = 'DIALOG_CLOSE_SUCCESS'
export const onDialogCloseSuccess = makeActionCreator(DIALOG_CLOSE_SUCCESS)

export const DIALOG_OPEN_SUCCESS = 'DIALOG_OPEN_SUCCESS'
export const onDialogOpenSuccess = makeActionCreator(DIALOG_OPEN_SUCCESS)

export const MAKE_SECOND_CALL = 'MAKE_SECOND_CALL'
export const MAKE_SECOND_CALL_ERROR = 'MAKE_SECOND_CALL_ERROR'
export const MAKE_SECOND_CALL_SUCCESS = 'MAKE_SECOND_CALL_SUCCESS'
export const onMakeSecondCallQuote = makeActionCreator(MAKE_SECOND_CALL)
export const onMakeSecondCallQuoteError = makeActionCreator(MAKE_SECOND_CALL_ERROR, 'payload')
export const onMakeSecondCallQuoteSuccess = makeActionCreator(MAKE_SECOND_CALL_SUCCESS, 'payload')
export const onMakeSecondCallQuoteThunk = payload => async (dispatch, getState) => {
  dispatch(onMakeSecondCallQuote())
  try {
    const {
      basicInfo: { id }
    } = getState().quoteBasicInformation
    await makeSecondCallQuote({ id })
    dispatch(onGetQuoteSummaryThunk({ quoteId: payload.quoteId }))
    return dispatch(onDialogCloseSuccess())
  } catch (error) {
    return dispatch(
      onMakeSecondCallQuoteError({
        error: {
          code: error.code,
          message: error.message
        }
      })
    )
  }
}
